export const AWS_REGION = 'us-east-1';

export const REGION_SHORTHAND = 'US';
